import { Component, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common'; 
import { Router } from '@angular/router';
import { Location } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-header-old',
  templateUrl: './header-old.component.html',
  styleUrls: ['./header-old.component.css'],
})
export class HeaderComponent implements OnInit {
  route:string = '';

  constructor(location: Location, public router: Router) {
    router.events.subscribe((val) => {
      if(location.path() != ''){
        if($('.header').hasClass('landingpage')){
          $(".header").removeClass("landingpage");
        }        
      }
    });
  }
  // toggleClass: boolean = false;

  ngOnInit(): void {
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $(".header").addClass("stickyhdr");
        } else {
            $(".header").removeClass("stickyhdr");
        }
    });    
  }

  toToggleClass(){
    // this.toggleClass = true;
    let element = document.querySelector('.clickable-mainmenu');
    element?.classList.remove('inside');
  }
  
 
}
